<script>
import AppNavigatorMixin from '@/mixins/app_navigator'

export default {
  mixins: [AppNavigatorMixin],
  props: {
    reload: { default: false, type: Boolean }
  },
  methods: {
    childSelected: function(child) {
      if (child.path.name == this.$route.name) {
        if (child.path.params) {
          return (
            JSON.stringify(child.path.params) ==
            JSON.stringify(this.$route.params)
          )
        } else {
          return true
        }
      } else if (
        child.path.name == 'FormSearch' &&
        /^FormEdit/.test(this.$route.name)
      ) {
        if (child.path.params.formType == this.$route.params.formType) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<template>
  <div class="AppNavigatorLink" :class="selClass">
    <a v-if="dataObj.reload" :href="dataObj.path">{{ dataObj.label }}</a>
    <router-link v-else :to="dataObj.path">{{ dataObj.label }}</router-link>
    <div class="submenu">
      <template v-for="child in dataObj.children">
        <a
          v-if="child.reload"
          :key="child.label"
          :href="child.path"
          :class="selClass"
          >{{ child.label }}</a
        >
        <router-link
          v-show="child.alwaysVisible || isSelected || childSelected(child)"
          v-else
          :key="child.label"
          :to="child.path"
          :class="{ selected: childSelected(child) }"
        >
          {{ child.label }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<style>
.AppNavigatorLink {
  font-size: 14pt;
  line-height: 1.6em;
  padding-left: 20px;
}
.AppNavigatorLink a {
  display: block;
}
.AppNavigatorLink.selected > a,
.AppNavigatorLink a.selected {
  font-weight: bold;
}
.AppNavigatorLink a:link,
.AppNavigatorLink a:visited,
.AppNavigatorLink a:hover,
.AppNavigatorLink a:active {
  color: #fff;
  text-decoration: none;
}
.AppNavigatorLink a:hover,
.AppNavigatorLink a:active {
  text-decoration: underline;
}
.AppNavigatorLink > .submenu {
  padding-left: 20px;
}
</style>
